import { useNavigate } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

export const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="bg-[#02182B] min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-md space-y-6">
        {/* 404 */}
        <p className="text-8xl font-black text-[#FD802E] leading-none">404</p>

        {/* Headline */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-white">Page not found</h1>
          <p className="text-gray-400 text-sm leading-relaxed">
            This route doesn't exist or was moved. Check the URL or head back to the home screen.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate('/')}
            className="flex items-center justify-center gap-2 bg-[#FD802E] text-[#233D4C] font-semibold px-6 py-3 rounded-lg hover:bg-[#ff8f45] transition-colors"
          >
            <Home size={16} /> Go Home
          </button>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 bg-[#233D4C] border border-[#2a4a5c] text-white px-6 py-3 rounded-lg hover:bg-[#2a4a5c] transition-colors"
          >
            <ArrowLeft size={16} /> Go Back
          </button>
        </div>
      </div>
    </div>
  )
}
